import { API_ENDPOINTS } from '../../Utils/ApiConfig';

/**
 * Updates questionnaire questions by sending the entire questions array
 * @param {string} questionnaireId - The questionnaire ID
 * @param {Array} questions - Complete array of questions
 * @param {Object} user - User session object with access_token
 * @returns {Promise} - Response from the API
 */
export const updateQuestionnaireQuestions = async (questionnaireId, questions, user) => {
  if (!user?.access_token) {
    throw new Error('User session not available');
  }

  const response = await fetch(API_ENDPOINTS.UPDATE_QUESTIONNAIRE_JSON, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.access_token}`
    },
    body: JSON.stringify({
      questionnaire_id: questionnaireId,
      questionnaire_json: {
        questions: questions
      }
    })
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.status} ${response.statusText}`);
  }

  return response.json();
};

/**
 * Updates challenge questions by sending the entire questions array
 * @param {string} challengeId - The challenge ID
 * @param {Array} questions - Complete array of questions
 * @param {Object} user - User session object with access_token
 * @returns {Promise} - Response from the API
 */
export const updateChallengeQuestions = async (challengeId, questions, user) => {
  if (!user?.access_token) {
    throw new Error('User session not available');
  }

  const response = await fetch(API_ENDPOINTS.UPDATE_CHALLENGE_JSON, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.access_token}`
    },
    body: JSON.stringify({
      challenge_id: challengeId,
      challenge_json: {
        questions: questions
      }
    })
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.status} ${response.statusText}`);
  }

  return response.json();
};
